import React from "react";
import PropTypes from "prop-types";
import { Icon } from "@iconify/react";
import { Button } from "../../odc-ui";
import styled from "styled-components/macro";

const StyledButton = styled(Button)`
  gap: 5px;
`;

function SubmittingButton({
  type,
  className,
  onClick,
  fullWidth,
  submitting,
  text,
  submittingText,
  textTransform,
}) {
  return (
    <StyledButton
      type={type}
      className={className}
      onClick={onClick}
      fullWidth={fullWidth}
      textTransform={textTransform}
    >
      {submitting ? (
        <>
          <Icon icon="eos-icons:loading" /> {submittingText}
        </>
      ) : (
        text
      )}
    </StyledButton>
  );
}

SubmittingButton.propTypes = {
  type: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  fullWidth: PropTypes.bool,
  submitting: PropTypes.bool,
  text: PropTypes.string,
  submittingText: PropTypes.string,
  textTransform: PropTypes.string,
};

export default SubmittingButton;
